export const users = {
  navigation: {
    forCreators: "Alkotóknak",
    login: "Bejelentkezés",
  },
  hero: {
    badge: "Vásárlói Fiók",
    title: "Már vásároltál egy creatortól?",
    description:
      "Lépj be a fiókodba, hogy hozzáférj megvásárolt tartalmaidhoz, időpontjaidhoz és üzeneteidhez. Minden vásárlásod egy helyen.",
    loginCta: "Bejelentkezés",
    noAccount: "Még nincs fiókod?",
    signUpLink: "Regisztrálj itt",
    features: [
      "Vásárlásaid",
      "Időpontjaid",
      "Tartalmaid",
      "Üzeneteid",
    ],
    featuresDesc: [
      "Láthatod az összes vásárlásodat és letöltheted számlád",
      "Kezelheted foglalásaidat és időpontjaidat",
      "Hozzáférhetsz digitális tartalmaidhoz",
      "Olvashatsz és küldhetsz üzeneteket",
    ],
  },
  afterLogin: {
    title: "Mit érhetsz el bejelentkezés után?",
    description:
      "Fiókodban minden egy helyen: vásárlásaid, időpontjaid, tartalmaid és üzeneteid",
    items: [
      {
        title: "Megvásárolt tartalmak",
        description:
          "Minden digitális tartalmad egy helyen - e-könyvek, kurzusok, sablonok - letölthető és újra elérhető",
      },
      {
        title: "Vásárlási előzmények",
        description:
          "Láthatod az összes vásárlásodat, árakat, dátumokat és letöltheted számlád PDF formátumban",
      },
      {
        title: "Foglalt időpontok",
        description:
          "Kezeld konzultációidat, workshopjaidat és találkozóidat egy átlátható naptárban",
      },
      {
        title: "Megrendelt videók",
        description:
          "Kövesd személyre szabott videókéréseid státuszát és töltsd le a kész videókat",
      },
      {
        title: "Üzenetváltások",
        description:
          "Olvashatsz és küldhetsz üzeneteket közvetlenül a creatoroknak egy chat felületen",
      },
    ],
  },
  howItWorks: {
    title: "Hogyan működik?",
    description: "Három egyszerű lépésben kapcsolódhatsz kedvenc alkotóidhoz",
    steps: [
      {
        title: "Böngéssz alkotók között",
        description:
          "Fedezz fel alkotókat és nézd meg, milyen tartalmakat és szolgáltatásokat kínálnak. Kövesd kedvenceidet, hogy értesülj az újdonságokról.",
      },
      {
        title: "Válassz és vásárolj",
        description:
          "Találd meg a számodra érdekes tartalmat vagy szolgáltatást, és fizetsd ki biztonságosan. Többféle fizetési módot támogatunk.",
      },
      {
        title: "Élvezd a tartalmat",
        description:
          "Digitális tartalmakhoz azonnal hozzáférhetsz, időpontokat pedig a naptáradban kezelheted. Minden egy helyen, egyszerűen.",
      },
    ],
  },
  benefits: {
    title: "Mit kapsz?",
    description:
      "Egyedi élményeket és tartalmakat közvetlenül kedvenc alkotóidtól",
    items: [
      {
        title: "Exkluzív tartalmak",
        description:
          "Férj hozzá különleges digitális tartalmakhoz, amelyeket máshol nem találsz meg - e-könyvek, kurzusok, oktatóanyagok és még sok más.",
      },
      {
        title: "Személyes találkozók",
        description:
          "Foglalj egyéni konzultációkat vagy csoportos workshopokat kedvenc alkotóiddal, és tanulj közvetlenül tőlük.",
      },
      {
        title: "Személyre szabott videók",
        description:
          "Kérj személyre szabott videóüzeneteket különleges alkalmakra vagy inspirációért kedvenc alkotóidtól.",
      },
      {
        title: "Közvetlen kapcsolat",
        description:
          "Chatelj alkotókkal, tegyél fel kérdéseket és kapj válaszokat közvetlenül azoktól, akiket követsz.",
      },
      {
        title: "Különleges ajánlatok",
        description:
          "Juttatások, kedvezmények és különleges csomagok csak a platformon keresztül vásárló rajongóknak.",
      },
      {
        title: "Minden egy helyen",
        description:
          "Kezeld vásárlásaidat, időpontjaidat, tartalmaidat és üzeneteidet egy központi felületen.",
      },
    ],
  },
  features: {
    title: "Miért válassz minket?",
    description: "A legjobb élmény alkotókkal való kapcsolatteremtéshez",
    items: [
      {
        title: "Biztonságos fizetés",
        description:
          "Minden tranzakció titkosított és biztonságos. Többféle fizetési módot támogatunk.",
      },
      {
        title: "Vásárlóvédelem",
        description:
          "Minden vásárlásod védett. Ha bármilyen probléma van, segítünk megoldani.",
      },
      {
        title: "Azonnali hozzáférés",
        description:
          "Digitális tartalmakhoz azonnal hozzáférhetsz a vásárlás után.",
      },
      {
        title: "Minőségi tartalmak",
        description:
          "Minden alkotót ellenőrzünk, hogy csak magas minőségű tartalmakat kapj.",
      },
      {
        title: "Egyszerű kezelés",
        description:
          "Intuitív felület, ahol könnyen megtalálod, amit keresel és kezeled vásárlásaidat.",
      },
      {
        title: "Támogatás 24/7",
        description:
          "Ügyfélszolgálatunk mindig rendelkezésedre áll, ha segítségre van szükséged.",
      },
    ],
  },
  faq: {
    title: "Gyakran Ismételt Kérdések",
    items: [
      {
        question: "Hogyan vásárolhatok tartalmakat?",
        answer:
          "Böngészd kedvenc alkotóid profilját, válaszd ki az érdekes tartalmat vagy szolgáltatást, és kattints a 'Vásárlás' gombra. A fizetés után azonnal hozzáférhetsz a digitális tartalmakhoz, vagy megjelenik az időpontod a naptáradban.",
      },
      {
        question: "Milyen fizetési módokat fogadtok el?",
        answer:
          "Bankkártyát (Visa, Mastercard), banki átutalást és egyéb népszerű online fizetési módokat támogatunk. Minden tranzakció biztonságos és titkosított.",
      },
      {
        question: "Visszakérhetem a pénzem?",
        answer:
          "Digitális tartalmaknál a vásárlás után 14 napon belül kérhetsz visszatérítést, ha nem nyitottad meg a tartalmat. Szolgáltatások esetén az alkotó visszatérítési szabályai érvényesek.",
      },
      {
        question: "Hogyan férjek hozzá a megvásárolt tartalmaimhoz?",
        answer:
          "Bejelentkezés után a 'Vásárlásaim' menüpontban megtalálod az összes megvásárolt tartalmat. Digitális termékek azonnal letölthetők vagy megtekinthetők.",
      },
      {
        question: "Mi történik, ha lemondok egy időpontot?",
        answer:
          "Az időpontokat legkésőbb 24 órával az időpont előtt lemondhatod díjmentesen. Ezt a 'Időpontjaim' menüpontban teheted meg. A lemondási szabályok alkotónként eltérhetnek.",
      },
      {
        question: "Hogyan tudom követni kedvenc alkotóimat?",
        answer:
          "Minden alkotó profiljánál található egy 'Követés' gomb. Ha követsz valakit, értesítést kapsz az új tartalmairól és ajánlatairól.",
      },
      {
        question: "Biztonságos az adataim megadása?",
        answer:
          "Igen, minden adatot titkosítva tárolunk és csak biztonságos kapcsolaton keresztül továbbítunk. Nem osztjuk meg adataidat harmadik féllel marketing célokra.",
      },
      {
        question: "Kaphatok számlát a vásárlásaimról?",
        answer:
          "Igen, minden vásárlásról automatikusan számlát állítunk ki, amelyet a 'Vásárlásaim' menüpontban letölthetsz PDF formátumban.",
      },
    ],
  },
  newsletter: {
    title: "Iratkozz fel hírlevelünkre",
    description:
      "Értesülj elsőként új alkotókról, különleges ajánlatokról és exkluzív tartalmakról!",
    placeholder: "Add meg az email címed",
    cta: "Feliratkozom",
    success: "Köszönjük! Sikeresen feliratkoztál hírlevelünkre!",
  },
  footer: {
    description:
      "A platform, ahol közvetlen kapcsolatba léphetsz kedvenc alkotóiddal.",
    quickLinks: "Gyors linkek",
    forCreators: "Alkotóknak",
    login: "Bejelentkezés",
    followUs: "Kövess minket",
    copyright: "© 2025 Bespire. Minden jog fenntartva.",
  },
  creatorHighlights: {
    title: "Kreátoraink exkluzív tartalmai",
    subtitle: "Fedezd fel az általad követett kreátorok legújabb tartalmait a felhasználói fiókodban",
    viewButton: "Megtekintés",
  },
  testimonials: {
    title: "Mit mondanak rólunk?",
    description: "Vásárlóink véleménye a platformról és az alkotókról",
    items: [
      {
        name: "Kiss Anna",
        role: "Jóga gyakorló",
        content: "Nagyon egyszerű volt lefoglalni az első órámat. Minden egy helyen van!",
      },
      {
        name: "Nagy Péter",
        role: "Kurzus vásárló",
        content: "A digitális tartalmak azonnal elérhetőek voltak. Nagyon elégedett vagyok.",
      },
      {
        name: "Kovács Béla",
        role: "Coach kliens",
        content: "A chat felületen gyorsan tudtam beszélni a mentorommal. Szuper!",
      },
    ],
  },
  getStarted: {
    title: "Készen állsz az indulásra?",
    description: "Csatlakozz te is a közösségünkhöz és élvezd az exkluzív tartalmakat!",
    button: "Regisztráció",
  },
  login: {
    title: "Bejelentkezés",
    subtitle: "Jelentkezz be a fiókodba",
    googleButton: "Bejelentkezés Google-lel",
    orDivider: "vagy",
    emailPlaceholder: "Email cím",
    passwordPlaceholder: "Jelszó",
    forgotPassword: "Elfelejtett jelszó?",
    loadingButton: "Bejelentkezés...",
    submitButton: "Bejelentkezés",
    registerPrompt: "Még nincs fiókod?",
    registerLink: "Regisztrálj itt",
    successToast: {
      title: "Sikeres bejelentkezés",
      description: "Üdvözöljük újra!",
    },
    errorToast: {
      title: "Hiba történt",
      description: "Ellenőrizze adatait!",
    },
  },
};
